import { SitemapItem } from './sitemap-item'

export class ExternalUrlItem extends SitemapItem {
  public parameters: string
  public url: string

  constructor(model: ExternalUrlItem) {
    super(model)
    this.parameters = model.parameters
    this.url = model.url
  }
}
